<div class="irembogov-journeys rounded p-3">
  <div class="row">
    <div class="col-12">
      <h5 class="mb-4">Journey Services Mapping</h5>
      <p class="text-muted mb-4">Configure journey service.</p>

      <div class="d-flex justify-content-end">
        <div *ngIf="loadingServices" class="me-3">
          <span class="me-2 text-primary">Loading services...</span>
          <i class="fa fa-spinner fa-spin"></i>
        </div>
      </div>
    </div>
  </div>

  <!-- Side-by-side layout -->
  <div class="w-100 d-flex">
    <!-- Visual Editor - Left Side (60%) -->
    <div class="flex-grow-1 me-3 preview-section-wrapper" style="width: 60%">
      <form
        [formGroup]="form"
        (ngSubmit)="submit()"
        class="preview-service-change-request-json-formdata-widget">
        <div
          *ngIf="loadingFields"
          class="alert alert-info d-flex align-items-center mb-4">
          <i class="fa fa-info-circle me-2"></i>
          <span>Loading form fields for selected services...</span>
        </div>

        <formly-form
          [model]="model"
          [fields]="fields"
          [options]="options"
          [form]="form"></formly-form>
      </form>
    </div>

    <!-- Code Editor - Right Side (40%) -->
    <div class="justify-self side-pane-wrapper" style="width: 40%">
      <div class="code-editor-section">
        <div class="mb-3">
          <div class="form-group">
            <div class="input-group">
              <json-editor
                [options]="jsonEditorOptions"
                id="journeyEditor"
                class="form-control p-0 json-form-data-field"
                (change)="onJsonEditorChange($event)"
                #jsonEditor>
              </json-editor>
            </div>
            <div
              class="form-error w-100 small text-danger"
              *ngIf="jsonEditorErrors.length > 0">
              JSON input is invalid
              <ol>
                <li
                  class="w-100 small"
                  *ngFor="let error of jsonEditorErrors; let index = index">
                  <small>{{ error.message || error }}</small>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- Submit button -->
      <div class="d-flex justify-content-end mt-4">
        <button
          type="button"
          class="btn btn-secondary me-2"
          (click)="skipJourneyMapping()">
          Skip
        </button>
        <button
          type="button"
          [disabled]="
            !form.valid ||
            jsonEditorErrors.length > 0 ||
            loadingServices ||
            loadingFields ||
            isLoading
          "
          class="btn btn-primary"
          (click)="submit()">
          <div
            *ngIf="loadingServices || loadingFields || isLoading"
            class="spinner-border spinner-border-sm me-2"
            role="status"></div>
          Continue
        </button>
      </div>
    </div>
  </div>
</div>
